//~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TEST ~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TODO remove - only for test purposes
//import TestRoute from "./components/routes/DummyRoutes/TestRoute";
//import TestReport from "./components/routes/DummyRoutes/TestReport";
//import exampleCheckInAPIResponse from "./components/routes/DummyRoutes/exampleResponse";
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~ TEST ~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// MODULES
import {
    createBrowserRouter,
    Navigate,
    Outlet,
    RouterProvider,
} from "react-router-dom";

// COMPONENTS

// HOOKS
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthContext } from "./hooks/context/AuthContext";
import LoginOrCreateUser, {
    AuthFlowStep,
} from "./components/routes/LoginOrCreateUser/LoginOrCreateUser";

// GENERAL ROUTES
import ProtectedRoute from "./components/routes/AuthWrapper/ProtectedRoute";
import TempNotFound from "./components/routes/NotFound/TempNotFound";
import ShareReport from "./components/routes/Reports/ShareReport";
import LegacyReport from "./components/routes/Reports/LegacyReport";
import Reports from "./components/routes/Reports/Reports";
import Dashboard from "./components/routes/Dashboard/Dashboard";

// PROMO ROUTES
//import GoPremium from "./components/ui/landers/LegacyTesting/LaborDayPromo";
//import LaborDayPromo from "./components/ui/landers/LegacyTesting/LaborDayPromo";
//import LaborDayPromoV2 from "./components/ui/landers/LegacyTesting/LaborDayPromoV2";
import OopsAlreadyPremium from "./components/ui/inputs/OopsAlreadyPremium";
import CongratsLander from "./components/ui/landers/GoPremium/CongratsLander";
import GoPremiumLander from "./components/ui/landers/GoPremium/GoPremiumLander";
import ManageSubscription from "./components/routes/ManageSubscription/ManageSubscription";
import ForgotPassword from "./components/routes/ForgotPassword/ForgotPassword";
import ForgotPasswordCode from "./components/routes/ForgotPassword/ForgotPasswordCode";
import ForgotPasswordFlow from "./components/routes/ForgotPassword/ForgotPasswordFlow";
import ForgotPasswordUpdateVersion from "./components/routes/ForgotPassword/ForgotPasswordUpdateVersion";
import Unsubscribe from "./components/routes/Unsubscribe/Unsubscribe";
import VerifyAccount from "./components/routes/VerifyAccount/VerifyAccount";
import PremiumExclusiveLander from "./components/ui/landers/PremiumExclusive/PremiumExclusiveLander";
import LoyaltyOfferLander from "./components/ui/landers/LoyaltyOffer/LoyaltyOfferLander";
import OfferExpired from "./components/ui/inputs/OfferExpired";
import PremiumMonthlyLander from "./components/ui/landers/PremiumCheckout/PremiumMonthlyLander";
import PremiumYearlyLander from "./components/ui/landers/PremiumCheckout/PremiumYearlyLander";
import PremiumCheckoutCongrats from "./components/ui/landers/PremiumCheckout/PremiumCheckoutCongrats";
import PremiumCheckoutOops from "./components/ui/landers/PremiumCheckout/PremiumCheckoutOops";

// TYPES / ENUMS

// ROUTES

/* TODO move to central location */
export enum IHRAccountType {
    Free = "FREE_USER",
    Premium = "PREMIUM_USER",
}

export const ScrollReset = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Wait for new route layout to paint
        requestAnimationFrame(() => {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            window.scrollTo({ top: 0 });
        });
    }, [pathname]);

    return null;
};

function App() {
    const { isSignedIn, isAuthResolved } = useAuthContext();

    // const scrollChunks = [...document.querySelectorAll("*")].filter(
    //     (el) => el.scrollHeight > el.clientHeight,
    // );
    const LoginRouteGuard: React.FC = () => {
        const { isSignedIn, isAuthResolved } = useAuthContext();

        if (!isAuthResolved) return null; // Or a loading spinner
        if (isSignedIn) return <Navigate to="/dashboard" replace />;
        return <LoginOrCreateUser authStep={AuthFlowStep.SignIn} />;
    };

    const router = createBrowserRouter([
        // {
        //     path: "/login",
        //     element:
        //         isAuthResolved && isSignedIn ? (
        //             <Navigate to="/dashboard" replace />
        //         ) : (
        //             <LoginOrCreateUser
        //                 authStep={AuthFlowStep.SignIn}
        //                 //isLoading={isLoading}
        //             />
        //         ),
        //     errorElement: <TempNotFound />,
        // },
        {
            path: "/login",
            element: <LoginRouteGuard />,
            errorElement: <TempNotFound />,
        },
        // Don't expose this route for safety reasons
        // See: https://app.asana.com/1/29383445232572/project/1205357977323125/task/1211293164183570?focus=true
        // {
        //     path: "/get-started",
        //     element:
        //         isAuthResolved && isSignedIn ? (
        //             <Navigate to="/dashboard" replace />
        //         ) : (
        //             <LoginOrCreateUser authStep={AuthFlowStep.CreateUser} />
        //         ),
        //     errorElement: <TempNotFound />,
        // },
        {
            path: "/reports",
            element: (
                <>
                    <Outlet />
                </>
            ),
            errorElement: <TempNotFound />,
            children: [
                {
                    index: true, // if exact match
                    element: (
                        // root path is protected because of api call
                        <ProtectedRoute>
                            <Reports />
                        </ProtectedRoute>
                    ),
                },
            ],
        },
        {
            path: "/report",
            element: (
                <>
                    <Outlet />
                </>
            ),
            errorElement: <TempNotFound />,
            // Routed this way for legacy reasons
            children: [
                {
                    index: true, // exact match
                    // TODO - replace with 404
                    element: <TempNotFound />,
                },
                {
                    path: ":reportId", // matches /reports/literally-anything....
                    element: <ShareReport />,
                },
            ],
        },
        {
            path: "/heartrate/report.jsp", //report passed as ?token={reportId}
            element: <LegacyReport />,
        },
        {
            path: "/dashboard",
            element: (
                <ProtectedRoute>
                    <Dashboard />,
                </ProtectedRoute>
            ),
            errorElement: <TempNotFound />,
        },
        {
            path: "/manage-subscription",
            element: (
                <ProtectedRoute>
                    <ManageSubscription />,
                </ProtectedRoute>
            ),
            errorElement: <TempNotFound />,
        },
        {
            //heartrate/report.jsp?token=2449082162-1292135611-2c634b-2bd515b75d31aed8200f007a68673c255c696033-1746123543783
            //http://localhost:3000/heartrate/report.jsp?token=2449082162-1292135611-2c634b-2bd515b75d31aed8200f007a68673c255c696033-1746123543783
            path: "/test",
            element: (
                // <ForgotPasswordCode
                //     onRequestNewCode={() => {}}
                //     onSubmitCode={(onSubmitSuccess, onSubmitFail) => {}}
                // />
                <ForgotPasswordUpdateVersion
                    onReturnToSignIn={() => {
                        <Navigate to="/login" replace />;
                    }}
                />
            ),
            errorElement: <TempNotFound />,
        },
        {
            path: "/go-premium/:user_id",
            element: <GoPremiumLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/premium-exclusive/:user_id",
            element: <PremiumExclusiveLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/loyalty-offer/:user_id",
            element: <LoyaltyOfferLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/premium-monthly/:user_id",
            element: <PremiumMonthlyLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/premium-yearly/:user_id",
            element: <PremiumYearlyLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/premium-checkout-success/",
            element: <PremiumCheckoutCongrats />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/premium-already/",
            element: <PremiumCheckoutOops />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/checkout-success/",
            element: <CongratsLander />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/already-premium/",
            element: <OopsAlreadyPremium />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/offer-expired/",
            element: <OfferExpired />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/unsubscribe",
            element: <Unsubscribe />,
            errorElement: <TempNotFound />,
        },
        {
            path: "/verify-account",
            element: <VerifyAccount />,
            errorElement: <TempNotFound />,
        },
        // {
        //     path: "/forgot-password",
        //     element: <ForgotPassword onCancel={() => {}}/>,
        //     errorElement: <TempNotFound />,
        // },
        // {
        //     path: "/forgot-password-code",
        //     element: <ForgotPasswordCode />,
        //     errorElement: <TempNotFound />,
        // },
        {
            path: "/forgot-password",
            element: <ForgotPasswordFlow />,
            errorElement: <TempNotFound />,
        },
    ]);

    return <RouterProvider router={router} />;
    //return <div>asdf</div>;
}

export default App;
